import { GridColDef } from '@microservices/wiskey-react-table-component'
import { MobileSearchAssistant } from '@mobileTypes'

export const MOBILE_SEARCH_ASSISTANTS_COLUMNS: GridColDef[] = [
  {
    field: 'title',
    headerName: 'Title',
    flex: 1,
    minWidth: 200,
  },
  {
    field: 'objectCode',
    headerName: 'Object Code',
    flex: 1,
    minWidth: 150,
  },
]

export const DEFAULT_MOBILE_SEARCH_ASSISTANT: Omit<
  MobileSearchAssistant,
  'id'
> = {
  configMode: 'simple',
  title: '',
  objectCode: '',
  filters: [],
  variables: [],
  eventFlows: [],
}

export const FILTER_TYPE_OPTIONS = [
  { value: 'SEARCHBAR', label: 'Search Bar', icon: 'search' },
  { value: 'SELECT', label: 'Select', icon: 'arrow-drop-down' },
  { value: 'MULTISELECT', label: 'Multi Select', icon: 'checklist' },
  { value: 'TOGGLE_BUTTONS', label: 'Toggle Buttons', icon: 'toggle-on' },
  { value: 'DAY_OFFSET', label: 'Day Offset', icon: 'calendar-today' },
  { value: 'DATE_RANGE', label: 'Date Range', icon: 'date-range' },
  { value: 'CHECKBOX', label: 'Checkbox', icon: 'check-box' },
]

export const RSQL_OPERATOR_OPTIONS = [
  { value: '==', label: 'Equals (==)' },
  { value: '!=', label: 'Not Equals (!=)' },
  { value: '=in=', label: 'In List (=in=)' },
  { value: '=out=', label: 'Not In List (=out=)' },
  { value: '=ge=', label: 'Greater or Equal (>=)' },
  { value: '=le=', label: 'Less or Equal (<=)' },
  { value: '=gt=', label: 'Greater Than (>)' },
  { value: '=lt=', label: 'Less Than (<)' },
  { value: '==*', label: 'Contains (like)' },
  { value: '=isnull=', label: 'Is Null' },
  { value: '=isnotnull=', label: 'Is Not Null' },
]
